module.exports = __webpack_public_path__ + "static/img/db.6954027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/db.jpg
// module id = aIzH
// module chunks = 44